const MAX = 200;

function id() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export default {
  namespaced: true,
  state: () => ({
    entries: [],
  }),
  getters: {
    entries: (s) => s.entries,
    /** Badge rojo: fallos reales (Vue/window) y respuestas HTTP problemáticas */
    errorBadgeCount: (s) =>
      s.entries.filter((e) => e.type === 'error' || e.type === 'api').length,
  },
  mutations: {
    push(state, payload) {
      const entry = {
        id: id(),
        at: new Date().toISOString(),
        type: payload.type || 'note',
        title: payload.title || '(sin título)',
        body: typeof payload.body === 'string' ? payload.body : JSON.stringify(payload.body, null, 2),
        stack: payload.stack || '',
        vueInfo: payload.vueInfo || '',
        route: payload.route || null,
      };
      state.entries.unshift(entry);
      if (state.entries.length > MAX) state.entries.pop();
    },
    clear(state) {
      state.entries = [];
    },
    remove(state, entryId) {
      state.entries = state.entries.filter((e) => e.id !== entryId);
    },
  },
};
